import React from 'react';

const UnderlineWithIcon = () => {
  return (
    <div style={styles.container}>
      <span style={styles.underline}></span>
      <span style={styles.icon}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M12 2L1 8l11 6 11-6-11-6zm0 10.5L2 8v4.75L12 17l10-4.25V8l-10 4.5z" />
        </svg>
      </span>
      <span style={styles.underline}></span>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    margin: '20px 0',
  },
  underline: {
    flex: 1,
    height: '2px',
    backgroundColor: '#17a2b8',
    margin: '0 10px',
  },
  icon: {
    display: 'inline-block',
    color: '#17a2b8',
    margin: '0 5px',
  },
};

export default UnderlineWithIcon;